export default __webpack_public_path__ + "static/media/Login.5d7f17c9.png";